export const dateFormatter = date => {
  try {
    return new Date(date).toLocaleDateString('de-AT', {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    });
  } catch (e) {
    return null;
  }
};
